<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="phone">
          <iframe src="http://mobileweb.yurencloud.com/#/loading" frameborder="0" width="320" height="580"></iframe>
        </div>


        <div class="title">加载器</div>
        <div class="sub-title">普通使用</div>
        <pre v-highlightjs="code1"><code class="html" ></code></pre>

        <div class="sub-title">添加提示语</div>
        <pre v-highlightjs="code2"><code class="html" ></code></pre>

        <div class="sub-title">变换大小</div>
        <pre v-highlightjs="code3"><code class="html" ></code></pre>

        <div class="sub-title" >同行</div>
        <pre v-highlightjs="code4"><code class="html" ></code></pre>

        <div class="sub-title">左中右对齐</div>
        <pre v-highlightjs="code5"><code class="html" ></code></pre>

        <div class="sub-title">属性</div>
        <yu-table :data="attributes1" :widths="widths1"/>


      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable } from 'yu.ui';
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Buttons',
  data() {
    return {
      code1: `
  <yu-loading />
      `,
      code2: `
  <yu-loading >加载中...</yu-loading>
      `,
      code3: `
  <yu-loading >加载中...</yu-loading>
  <yu-loading size="large" >加载中...</yu-loading>
  <yu-loading size="big" >加载中...</yu-loading>
      `,
      code4: `
  <yu-loading inline >加载中...</yu-loading>
  <yu-loading inline size="large" >加载中...</yu-loading>
  <yu-loading inline size="big" >加载中...</yu-loading>
      `,
      code5: `
  <yu-loading align="left" >加载中...</yu-loading>
  <yu-loading align="center" >加载中...</yu-loading>
  <yu-loading align="right" >加载中...</yu-loading>
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'size',
          description: '加载大小尺寸[large,big]',
          types: 'String',
          default: '无',
        },
        {
          prop: 'align',
          description: '加载对齐方式[left,center,right]',
          types: 'String',
          default: 'center',
        },
        {
          prop: 'inline',
          description: '加载变成inline-block元素',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'loading',
          description: '是否显示加载动画',
          types: 'Boolean',
          default: 'true',
        },
      ],
      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuTable,
    YuButton,
    YuText,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }

    .phone{
      text-align: center;
      iframe {
        margin: 20px auto;
        border-radius: 20px;
        &::-webkit-scrollbar {
          width: 0;
        }
        border: 10px solid $border;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue